import Vue from "vue";
import Router from "vue-router";
import Home from "@/pages/Home"; // 首页

import GongSiJianJie from "@/pages/GongSiJianJie"; // 公司简介单页
import SheHuiZeRen from "@/pages/SheHuiZeRen"; // 社会责任单页
import QiYeWenHua from "@/pages/QiYeWenHua"; // 企业文化单页
import QiYeZhanShi from "@/pages/QiYeZhanShi"; // 企业展示单页
import FaZhanLiCheng from "@/pages/FaZhanLiCheng"; // 发展历程单页
import ZiZhiRongYu from "@/pages/ZiZhiRongYu"; // 企业荣誉单页
import GongSiZiZhi from "@/pages/GongSiZiZhi"; // 公司资质单页
import DangJianGongHui from "@/pages/DangJianGongHui"; // 党建工会

import ChengGongAnLi from "@/pages/ChengGongAnLi"; // 典型案例
import ChengGongAnLi1 from "@/pages/ChengGongAnLi1"; // 典型案例1-智慧水务分类
import ChengGongAnLi2 from "@/pages/ChengGongAnLi2"; // 典型案例2-供水项目分类
import ChengGongAnLi3 from "@/pages/ChengGongAnLi3"; // 典型案例3-排水项目分类
import ChanPinJiYingYongShiPin from "@/pages/ChanPinJiYingYongShiPin"; // 产品及应用视频
import YuanGongFengCai from "@/pages/YuanGongFengCai"; // 员工风采
import XinWenZhongXin from "@/pages/XinWenZhongXin"; // 新闻列表页
import ArticleView from "@/pages/ArticleView"; // 新闻详情页

import XiWenView from "@/pages/XiWenView"; // 新闻详情页

import ChanPinZhongXin from "@/pages/ChanPinZhongXin"; // 产品列表页
import ProductView from "@/pages/ProductView"; // 产品详情页

import MeiTiKanKaiNa from "@/pages/MeiTiKanKaiNa"; // 媒体看凯纳
import HangYeXinWen from "@/pages/HangYeXinWen"; // 行业新闻
import QiYeDongTai from "@/pages/QiYeDongTai"; // 企业动态
import TongZhiGongGao from "@/pages/TongZhiGongGao"; // 通知公告

import WuLianWangChanPin from "@/pages/WuLianWangChanPin"; // 物联网产品
import JiFangHuanJingZiDongJianKongXiTong from "@/pages/JiFangHuanJingZiDongJianKongXiTong"; // 机房环境自动监控系统
import XinFangYiTiJi from "@/pages/XinFangYiTiJi"; // 信访一体机
import RuanJianChanPin from "@/pages/RuanJianChanPin"; // 软件产品
import YingJianChanPin from "@/pages/YingJianChanPin"; // 硬件产品
// import ZhiNengShuiBiao from "@/pages/ZhiNengShuiBiao"; // 智能水表
import CeShiPingTai from "../pages/CeShiPingTai.vue"; //测试平台

import JieJueFangAn from "@/pages/JieJueFangAn"; // 解决方案
import JieJueFangAnView from "@/pages/JieJueFangAnView"; // 解决方案详情

import ZhiHuiGongShui from "@/pages/ZhiHuiGongShui"; // 智慧供水解决方案
import ZhiHuiPaiShui from "@/pages/ZhiHuiPaiShui"; // 智慧排水解决方案
import NongCunShengHuoWuShuiZhiLi from "@/pages/NongCunShengHuoWuShuiZhiLi"; // 污水治理解决方案
import KaiNaShuiZhiFenXiYi from "@/pages/KaiNaShuiZhiFenXiYi"; // 水质分析仪
import ZhiHuiXinFang from "@/pages/ZhiHuiXinFang"; // 智慧信访

import ZhiHuiChengShi from "@/pages/ZhiHuiChengShi"; // 智慧城市解决方案
import GuanWangJianCe from "@/pages/GuanWangJianCe"; // 管网漏损监测解决方案

import JiShuZhiChiView from "@/pages/JiShuZhiChiView"; // 技术支持详情
import ChanPinShuoMingShuXiaZai from "@/pages/ChanPinShuoMingShuXiaZai"; // 产品说明书下载
import YunWeiFuWu from "@/pages/YunWeiFuWu"; // 运维服务
import SheMiYeWuFuWu from "@/pages/SheMiYeWuFuWu"; // 涉密业务服务

import WoMenDeKeHu from "@/pages/WoMenDeKeHu"; // 我们的客户
import HeZuoHuoBan from "@/pages/HeZuoHuoBan"; // 合作伙伴
import HeZuoJiGouYuGaoXiao from "@/pages/HeZuoJiGouYuGaoXiao"; // 合作机构与高校
import LianMengYuXieHui from "@/pages/LianMengYuXieHui"; // 联盟与协会
import KeHuYuLianMengView from "@/pages/KeHuYuLianMengView"; // 客户与联盟详情
import KeHuYuLianMengView1 from "@/pages/KeHuYuLianMengView1"; // 客户与联盟详情，临时

import Contact from "@/pages/Contact"; // 联系方式
import Map from "@/pages/Map"; // 地图

import SheHuiZhaoPin from "@/pages/SheHuiZhaoPin"; // 社会招聘
import XiaoYuanZhaoPin from "@/pages/XiaoYuanZhaoPin"; // 校园招聘
import JobList from "@/pages/JobList"; // 招聘列表
import JobView from "@/pages/JobView"; // 招聘详情
import QiYeHuaCe from "@/pages/QiYeHuaCe"; // 企业画册
import QiYeXuanChuanPian from "@/pages/QiYeXuanChuanPian"; //企业宣传册

Vue.use(Router);

var title = "哈尔滨凯纳科技股份有限公司";

// 解决重复点击路由报错的BUG
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

export default new Router({
  // mode:'history',
  //mode: "history", // 设置为 'history' 来启用 HTML5 History 模式
  routes: [
    {
      path: "/", // 首页
      name: "Home",
      component: Home,
      meta: { title: title }
    },
    {
      path: "/GongSiJianJie", // 公司简介
      name: "GongSiJianJie",
      component: GongSiJianJie,
      meta: { title: title }
    },
    {
      path: "/SheHuiZeRen", // 社会责任
      name: "SheHuiZeRen",
      component: SheHuiZeRen,
      meta: { title: title }
    },
    {
      path: "/QiYeWenHua", // 企业文化
      name: "QiYeWenHua",
      component: QiYeWenHua,
      meta: { title: title }
    },
    {
      path: "/QiYeZhanShi", // 企业展示
      name: "QiYeZhanShi",
      component: QiYeZhanShi,
      meta: { title: title }
    },
    {
      path: "/FaZhanLiCheng", // 发展历程
      name: "FaZhanLiCheng",
      component: FaZhanLiCheng,
      meta: { title: title }
    },
    {
      path: "/ZiZhiRongYu", // 企业荣誉
      name: "ZiZhiRongYu",
      component: ZiZhiRongYu,
      meta: { title: title }
    },
    {
      path: "/GongSiZiZhi", // 公司资质
      name: "GongSiZiZhi",
      component: GongSiZiZhi,
      meta: { title: title }
    },
    {
      path: "/DangJianGongHui", // 党建荣誉
      name: "DangJianGongHui",
      component: DangJianGongHui,
      meta: { title: title }
    },
    {
      path: "/ChengGongAnLi", // 典型案例
      name: "ChengGongAnLi",
      component: ChengGongAnLi,
      meta: { title: title }
    },
    {
      path: "/ChengGongAnLi1", // 典型案例1-智慧水务分类
      name: "ChengGongAnLi1",
      component: ChengGongAnLi1,
      meta: { title: title }
    },
    {
      path: "/ChengGongAnLi2", // 典型案例2-供水项目分类
      name: "ChengGongAnLi2",
      component: ChengGongAnLi2,
      meta: { title: title }
    },
    {
      path: "/ChengGongAnLi3", // 典型案例3-排水项目分类
      name: "ChengGongAnLi3",
      component: ChengGongAnLi3,
      meta: { title: title }
    },
    {
      path: "/YuanGongFengCai", // 员工风采
      name: "YuanGongFengCai",
      component: YuanGongFengCai,
      meta: { title: title }
    },
    {
      path: "/ChanPinJiYingYongShiPin", // 产品及应用视频
      name: "ChanPinJiYingYongShiPin",
      component: ChanPinJiYingYongShiPin,
      meta: { title: title }
    },
    {
      path: "/MeiTiKanKaiNa", // 媒体看凯纳
      name: "MeiTiKanKaiNa",
      component: MeiTiKanKaiNa,
      meta: { title: title }
    },
    {
      path: "/HangYeXinWen", // 行业新闻
      name: "HangYeXinWen",
      component: HangYeXinWen,
      meta: { title: title }
    },
    {
      path: "/QiYeDongTai", // 企业动态
      name: "QiYeDongTai",
      component: QiYeDongTai,
      meta: { title: title }
    },
    {
      path: "/TongZhiGongGao", // 通知公告
      name: "TongZhiGongGao",
      component: TongZhiGongGao,
      meta: { title: title }
    },
    {
      path: "/XinWenZhongXin", // 新闻中心
      name: "XinWenZhongXin",
      component: XinWenZhongXin,
      meta: { title: title }
    },
    {
      path: "/ArticleView", //
      name: "ArticleView",
      component: ArticleView,
      meta: { title: title }
    },
    {
      path: "/XiWenView", // 新闻详情页（公用）
      name: "XiWenView",
      component: XiWenView,
      meta: { title: title }
    },
    {
      path: "/ChanPinZhongXin", // 产品中心
      name: "ChanPinZhongXin",
      component: ChanPinZhongXin,
      meta: { title: title }
    },
    {
      path: "/WuLianWangChanPin", // 物联网产品
      name: "WuLianWangChanPin",
      component: WuLianWangChanPin,
      meta: { title: title }
    },
    {
      path: "/JiFangHuanJingZiDongJianKongXiTong", // 机房环境自动监控系统
      name: "JiFangHuanJingZiDongJianKongXiTong",
      component: JiFangHuanJingZiDongJianKongXiTong,
      meta: { title: title }
    },
    {
      path: "/XinFangYiTiJi", // 信访一体机
      name: "XinFangYiTiJi",
      component: XinFangYiTiJi,
      meta: { title: title }
    },
    {
      path: "/RuanJianChanPin", // 软件产品
      name: "RuanJianChanPin",
      component: RuanJianChanPin,
      meta: { title: title }
    },
    {
      path: "/YingJianChanPin", // 硬件产品
      name: "YingJianChanPin",
      component: YingJianChanPin,
      meta: { title: title }
    },
    // {
    //   path: "/ZhiNengShuiBiao", // 智能水表
    //   name: "ZhiNengShuiBiao",
    //   component: ZhiNengShuiBiao,
    //   meta: { title: title }
    // },
    {
      path: "/CeShiPingTai", // 测试平台
      name: "CeShiPingTai",
      component: CeShiPingTai,
      meta: { title: title }
    },
    {
      path: "/ProductView", // 产品详情页（公用）
      name: "ProductView",
      component: ProductView,
      meta: { title: title }
    },
    {
      path: "/JieJueFangAn", // 解决方案
      name: "JieJueFangAn",
      component: JieJueFangAn,
      meta: { title: title }
    },
    {
      path: "/JieJueFangAnView", // 解决方案详情
      name: "JieJueFangAnView",
      component: JieJueFangAnView,
      meta: { title: title }
    },
    {
      path: "/ZhiHuiGongShui", // 智慧供水解决方案
      name: "ZhiHuiGongShui",
      component: ZhiHuiGongShui,
      meta: { title: title }
    },
    {
      path: "/ZhiHuiPaiShui", // 智慧排水解决方案
      name: "ZhiHuiPaiShui",
      component: ZhiHuiPaiShui,
      meta: { title: title }
    },
    {
      path: "/NongCunShengHuoWuShuiZhiLi", // 污水治理解决方案
      name: "NongCunShengHuoWuShuiZhiLi",
      component: NongCunShengHuoWuShuiZhiLi,
      meta: { title: title }
    },
    {
      path: "/KaiNaShuiZhiFenXiYi", // 水质分析仪
      name: "KaiNaShuiZhiFenXiYi",
      component: KaiNaShuiZhiFenXiYi,
      meta: { title: title }
    },
    {
      path: "/ZhiHuiXinFang", // 智慧信访
      name: "ZhiHuiXinFang",
      component: ZhiHuiXinFang,
      meta: { title: title }
    },
    {
      path: "/ZhiHuiChengShi", // 智慧城市解决方案
      name: "ZhiHuiChengShi",
      component: ZhiHuiChengShi,
      meta: { title: title }
    },
    {
      path: "/GuanWangJianCe", // 管网漏损监测解决方案
      name: "GuanWangJianCe",
      component: GuanWangJianCe,
      meta: { title: title }
    },

    {
      path: "/JiShuZhiChiView", // 技术支持详情
      name: "JiShuZhiChiView",
      component: JiShuZhiChiView,
      meta: { title: title }
    },
    {
      path: "/ChanPinShuoMingShuXiaZai", // 产品说明书下载
      name: "ChanPinShuoMingShuXiaZai",
      component: ChanPinShuoMingShuXiaZai,
      meta: { title: title }
    },
    {
      path: "/YunWeiFuWu", // 运维服务
      name: "YunWeiFuWu",
      component: YunWeiFuWu,
      meta: { title: title }
    },
    {
      path: "/SheMiYeWuFuWu", // 涉密业务服务
      name: "SheMiYeWuFuWu",
      component: SheMiYeWuFuWu,
      meta: { title: title }
    },
    {
      path: "/WoMenDeKeHu", // 我们的客户
      name: "WoMenDeKeHu",
      component: WoMenDeKeHu,
      meta: { title: title }
    },
    {
      path: "/HeZuoHuoBan", // 合作伙伴
      name: "HeZuoHuoBan",
      component: HeZuoHuoBan,
      meta: { title: title }
    },
    {
      path: "/HeZuoJiGouYuGaoXiao", // 合作机构与高校
      name: "HeZuoJiGouYuGaoXiao",
      component: HeZuoJiGouYuGaoXiao,
      meta: { title: title }
    },
    {
      path: "/LianMengYuXieHui", // 联盟与协会
      name: "LianMengYuXieHui",
      component: LianMengYuXieHui,
      meta: { title: title }
    },
    {
      path: "/KeHuYuLianMengView", // 客户与联盟详情
      name: "KeHuYuLianMengView",
      component: KeHuYuLianMengView,
      meta: { title: title }
    },
    {
      path: "/KeHuYuLianMengView1", // 客户与联盟详情，临时
      name: "KeHuYuLianMengView1",
      component: KeHuYuLianMengView1,
      meta: { title: title }
    },
    {
      path: "/Contact", // 联系方式
      name: "Contact",
      component: Contact,
      meta: { title: title }
    },
    {
      path: "/Map", // 地图
      name: "Map",
      component: Map,
      meta: { title: title }
    },
    {
      path: "/SheHuiZhaoPin", // 社会招聘
      name: "SheHuiZhaoPin",
      component: SheHuiZhaoPin,
      meta: { title: title }
    },
    {
      path: "/XiaoYuanZhaoPin", // 校园招聘
      name: "XiaoYuanZhaoPin",
      component: XiaoYuanZhaoPin,
      meta: { title: title }
    },
    {
      path: "/JobList", // 招聘列表
      name: "JobList",
      component: JobList,
      meta: { title: title }
    },
    {
      path: "/JobView", // 招聘详情
      name: "JobView",
      component: JobView,
      meta: { title: title }
    },
    {
      path: "/QiYeHuaCe", // 企业画册
      name: "QiYeHuaCe",
      component: QiYeHuaCe,
      meta: { title: title }
    },
    {
      path: "/QiYeXuanChuanPian", // 企业宣传片
      name: "QiYeXuanChuanPian",
      component: QiYeXuanChuanPian,
      meta: { title: title }
      
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js